import {
  IMAGE_MIME_TYPES,
  IMAGE_MIME_TYPE_TO_SHORT_LABEL,
} from '../../../common';

export const DRIVER_LICENSE_MAX_SIZE_BYTES = 10 * 1024 * 1024;

export const DRIVER_LICENSE_ACCEPTED_MIME_TYPES = Object.freeze([
  IMAGE_MIME_TYPES.PNG,
  IMAGE_MIME_TYPES.JPEG,
]);

export const DRIVER_LICENSE_MIME_TO_SHORT_LABEL = Object.freeze(
  Object.fromEntries(
    DRIVER_LICENSE_ACCEPTED_MIME_TYPES.map((mimeType) => [
      mimeType,
      IMAGE_MIME_TYPE_TO_SHORT_LABEL[mimeType] ?? mimeType,
    ])
  )
);
